/**
 * OOTB SFRA JS code
 * DRP-453 implemented productTileSwatch
 */

'use strict';

var processInclude = require('base/util');
import { matchesBreakpoint } from './domUtil';
import { stickyScrollPosition } from './util';
const { queryAll } = require('./domUtil');

$(document).ready(function () {
    processInclude(require('./search/search'));
    processInclude(require('./search/productGrid'));
    processInclude(require('./search/productTileSwatch'));
    processInclude(require('./search/sortOrderMenu'));
    processInclude(require('./components/selectStore'));
    processInclude(require('./components/modal'));

    if (matchesBreakpoint('md')) {
        // 70px - size of PLP filter bar
        stickyScrollPosition(queryAll('.refinement-bar'), true, 70);
    }

    $('.search-results').on('click', '.quick-buy-add-toast .close', function (e) {
        e.preventDefault();
        $('.quick-buy-add-toast').addClass('d-none');
    });
});

processInclude(require('./productTile'));
processInclude(require('./pGiftCardQuickView'));
